import React from "react";

// Pantalla de selección de la sección pública: una serie de labels, uno debajo
// del otro, centrados, con tipografía bold y fondo transparente. Sin cards.
export default function PublicPickScreen({ title, subtitle, options = [], emptyText, onSelect, onBack }) {
  return (
    <div className="tpub-screen">
      <div className="tpub-head">
        {onBack && (
          <button type="button" className="tpub-back" onClick={onBack} aria-label="Volver">
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <polyline points="15 18 9 12 15 6" />
            </svg>
          </button>
        )}
        <div className="tpub-head-text">
          <div className="tpub-title">{title}</div>
          {subtitle && <div className="tpub-subtitle">{subtitle}</div>}
        </div>
      </div>

      {options.length === 0 ? (
        <p className="tpub-empty">{emptyText || "No hay opciones disponibles."}</p>
      ) : (
        <div className="tpub-options">
          {options.map((opt) => (
            <button key={opt.key} type="button" className="tpub-option" onClick={() => onSelect(opt.key)}>
              {opt.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
